import Icon from '@material-ui/core/Icon/Icon'
import React from 'react'
import LineTool from './LineTool'
import LineToolOptions from './LineToolOptions'
import MultilineTool from './MultilineTool'
import MultilineToolOptions from './MultilineToolOptions'
import OutlinerTool from './OutlinerTool'
import { ToolName as OutlinerToolname } from './OutlinerTool'
import OutlinerToolOptions from './OutlinerToolOptions'
import PointTool from './PointTool'
import PointToolOptions from './PointToolOptions'
import PolygonTool from './PolygonTool'
import RectangleTool from './RectangleTool'

const tools = {
  rectangle: {
    icon: <Icon>check_box_outline_blank</Icon>,
    component: RectangleTool,
    canvasStyles: {
      cursor: 'crosshair',
    },
    tooltip: 'Rectangle',
  },
  polygon: {
    icon: <Icon>change_history</Icon>,
    component: PolygonTool,
    canvasStyles: {
      cursor: 'crosshair',
    },
    tooltip: 'Polygon',
  },
  point: {
    icon: <Icon>place</Icon>,
    component: PointTool,
    canvasStyles: {
      cursor: 'crosshair',
    },
    tooltip: 'Point',
    options: PointToolOptions,
  },
  line: {
    icon: <Icon>trending_flat</Icon>,
    component: LineTool,
    canvasStyles: {
      cursor: 'crosshair',
    },
    tooltip: 'Line',
    options: LineToolOptions,
  },
  multiline: {
    icon: <Icon>timeline</Icon>,
    component: MultilineTool,
    canvasStyles: {
      cursor: 'crosshair',
    },
    tooltip: 'Multiline',
    options: MultilineToolOptions,
  },
  [OutlinerToolname]: {
    icon: <Icon>rounded_corner_outlined</Icon>,
    component: OutlinerTool,
    canvasStyles: {
      cursor: 'crosshair',
    },
    tooltip: 'Auto outliner',
    options: OutlinerToolOptions,
  },
}

export default tools
